import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ExtraOptions, PreloadAllModules, RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Location } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { OverlayModule } from '@angular/cdk/overlay';

import { RouterStateSnapshot, ActivatedRouteSnapshot, Router, RouteReuseStrategy } from '@angular/router';

import { MarkdownModule } from 'ngx-markdown';

import { FuseModule } from 'app/zdslogic-ui-shell/@fuse';
import { FuseConfigModule } from 'app/zdslogic-ui-shell/@fuse/services/config';
import { FuseMockApiModule } from 'app/zdslogic-ui-shell/@fuse/lib/mock-api';

import { RecaptchaModule } from 'ng-recaptcha';
import {
	NgxMatDatetimePickerModule,
	NgxMatNativeDateModule,
	NgxMatTimepickerModule
} from '@angular-material-components/datetime-picker';
import { MatNativeDateModule } from '@angular/material/core';

// import needed PrimeNG modules here
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { PanelModule } from 'primeng/panel';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons/faSearch';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { faShop } from '@fortawesome/free-solid-svg-icons';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';

import { GoogleMapsModule } from '@angular/google-maps';

import { SlideshowModule } from 'ng-simple-slideshow';
	
//zdslogic components
import { AppComponent } from 'app/app.component';
import { appRoutes } from 'app/app.routing';
import { AboutComponent } from './zdslogic-ui-plugins/games/about/about.component';
import { MapComponent } from './zdslogic-ui-plugins/map/map.component';
/*import { HomeComponent } from './zdslogic-ui-plugins/games/home/home.component';
import { InvadersComponent } from './zdslogic-ui-plugins/games/invaders/invaders.component';
import { BreakoutComponent } from './zdslogic-ui-plugins/games/breakout/breakout.component';
import { BirdyNamNamComponent } from './zdslogic-ui-plugins/games/birdy-nam-nam/birdy-nam-nam.component';
*/
import { AsteroidComponent } from './zdslogic-ui-plugins/games/asteroid/asteroid.component';
/*import { AlphaAdjustComponent } from './zdslogic-ui-plugins/games/alpha-adjust/alpha-adjust.component';
import { BlockadeComponent } from './zdslogic-ui-plugins/games/blockade/blockade.component';
import { BlocksComponent } from './zdslogic-ui-plugins/games/blocks/blocks.component';
import { CandyCrushComponent } from './zdslogic-ui-plugins/games/candy-crush/candy-crush.component';
import { CoinRunnerComponent } from './zdslogic-ui-plugins/games/coin-runner/coin-runner.component';
import { FlappyBirdComponent } from './zdslogic-ui-plugins/games/flappy-bird/flappy-bird.component';
import { SnakeComponent } from './zdslogic-ui-plugins/games/snake/snake.component';
import { SpaceInvadersComponent } from './zdslogic-ui-plugins/games/space-invaders/space-invaders.component';
import { SuperMarioLandComponent } from './zdslogic-ui-plugins/games/super-mario-land/super-mario-land.component';
import { TankComponent } from './zdslogic-ui-plugins/games/tank/tank.component';
import { GameOfLifeComponent } from './zdslogic-ui-plugins/games/game-of-life/game-of-life.component';
import { BasicPlaybackAndEventsComponent } from './zdslogic-ui-plugins/games/audio/web-audio/basic-playback-and-events/basic-playback-and-events.component';
*/

//zdslogic directives

//zdslogic modules
//import { AppRoutingModule } from './zdslogic-ui-plugins/games/routing/app-routing.module';
import { CoreModule } from 'app/zdslogic-ui-shell/core/core.module';
import { appConfig } from 'app/zdslogic-ui-shell/core/config/app.config';
import { LayoutModule } from 'app/zdslogic-ui-shell/layout/layout.module';
import { MaterialModule } from './zdslogic-ui-base/material/material.module';
import { SharedModule } from 'app/zdslogic-ui-base/shared/shared.module';
//import { NzModule } from './zdslogic-ui-base/nz/nz.module';
//import { ZdsCoreModule } from './zdslogic-ui-base/core';

//zdslogic services
import { AccountEventsService } from './zdslogic-ui-base/core/services/account.events.service';
import { AlertService } from './zdslogic-ui-base/alert/alert.service';
import { AngularLogPublishersService } from './zdslogic-ui-base/core/services/angular-log-publishers.service';
import { AngularLogService } from './zdslogic-ui-base/core/services/angular-log.service';

import { ApiService } from './zdslogic-ui-base/core/services/api.service';
//import { AuthorizationRouteGuard } from './zdslogic-ui-base/core/services/
//import { DataSharingService } from './zdslogic-ui-base/core/services/
import { ErrorService } from './zdslogic-ui-base/core/services/error.service';
import { JwtService } from './zdslogic-ui-base/core/services/jwt.service';
//import { LoginRouteGuard } from './zdslogic-ui-base/core/services/
import { MapApiService } from './zdslogic-ui-base/core/services/mapapi.service';
import { MyAccountService } from './zdslogic-ui-base/core/services/myaccountservice.service';
//import { RegistrationService } from './zdslogic-ui-base/core/services/
//import { ResizeService } from './zdslogic-ui-base/core/services/
//import { SubscriptionRouteGuard } from './zdslogic-ui-base/core/services/
//import { UsersService } from './zdslogic-ui-base/core/services/

const routerConfig: ExtraOptions = {
	preloadingStrategy: PreloadAllModules,
	scrollPositionRestoration: 'enabled'
};

@NgModule({
	declarations: [
		AppComponent,
//		AsteroidComponent,
		
/*
	AboutComponent,
	HomeComponent,
    InvadersComponent,
    BreakoutComponent,
    BirdyNamNamComponent,
    AsteroidComponent,
    AlphaAdjustComponent,
    BlockadeComponent,
    BlocksComponent,
    CandyCrushComponent,
    CoinRunnerComponent,
    FlappyBirdComponent,
    SnakeComponent,
    SpaceInvadersComponent,
    SuperMarioLandComponent,
    TankComponent,
    GameOfLifeComponent,
    BasicPlaybackAndEventsComponent,

*/
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		RouterModule.forRoot(appRoutes, routerConfig),
		ButtonModule,
		CKEditorModule,

		// Core module of your application
		CoreModule,

		FlexLayoutModule,
		FontAwesomeModule,
		FormsModule,
		ReactiveFormsModule,
		//FullCalendarModule,

		// Fuse, FuseConfig & FuseMockAPI
		FuseModule,
		FuseConfigModule.forRoot(appConfig),
		//FuseMockApiModule.forRoot(mockApiServices),

		GoogleMapsModule,
		HttpClientModule,

		// modules of your application

		LayoutModule,
		MaterialModule,
		//NzModule,
		//OverlayModule,
		//RegistrationModule,

		//ZdsCoreModule,

		// 3rd party modules that require global configuration via forRoot
		MarkdownModule.forRoot({})
	],
	exports: [
		RecaptchaModule,
		MaterialModule,
	],
	providers: [
		{
			provide: 'externalUrlRedirectResolver',
			useValue: (route: ActivatedRouteSnapshot, state: RouterStateSnapshot, location: Location) => {
				//window.location.href = (route.data as any).externalUrl;
				let url = (route.data as any).externalUrl;
				window.open(url, '_blank');
				let currentUrl = window.location.href;
				//location.go(currentUrl);
				//window.location.go(currentUrl);
			}
		},
		AccountEventsService,
		//AlertService,
		AngularLogService,
		AngularLogPublishersService,
		ApiService,
		//AuthorizationRouteGuard,
		//DataSharingService,
		ErrorService,
		JwtService,
		//LoginRouteGuard,
		MapApiService,
		MyAccountService,
		//RegistrationService,
		//ResizeService,
		//SubscriptionRouteGuard,
		//UsersService,
		//MyAccountService
	],

	bootstrap: [
		AppComponent
	]
})
export class AppModule {

	myrouter: Router;

	constructor(private library: FaIconLibrary, private router: Router) {

		//library.add(faSearch);

		library.addIcons(faSearch, faShop, faShoppingCart, faCaretDown);

		this.myrouter = router;

	}
}
